import { Box, Spinner } from '@chakra-ui/react';

import TextWithTooltip from '../../../../../components/TextWithTooltip';
import Select, { Option } from '../../../../../components/formComponents/Select';
import { TRIM_EXPLANATION } from '../../../../../utils/cars';

interface Props {
  kbbLoading: boolean;
  options: Option[];
}

const SelectTrim = ({ kbbLoading, options }: Props) => {
  if (kbbLoading) {
    return (
      <Box mt="24px !important">
        <Spinner />
      </Box>
    );
  }

  return (
    <>
      {options.length > 1 && (
        <>
          <Select
            display={options.length > 0 ? 'block' : 'none'}
            name="vehicleTrim"
            placeholder="Select Trim"
            alignSelf="self-start"
            w="full"
            mt={5}
            mb={2}
            options={options}
            menuListHeight="100px"
          />
          <TextWithTooltip label={TRIM_EXPLANATION}>What is my trim?</TextWithTooltip>
        </>
      )}
    </>
  );
};

export default SelectTrim;
